module.exports = __webpack_public_path__ + "img/9_45.b2a81bc0.png";